import { useState, useEffect, useCallback } from 'react';
import ReportsService from '@/services/reportsService';
import { toast } from 'react-hot-toast';

const useStockStatus = (initialFilters = {}) => {

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [branchSummary, setBranchSummary] = useState([]);
  const [total, setTotal] = useState(0);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    categoryId: '',
    stockStatus: '',
    sortBy: 'name',
    offset: 0,
    limit: 50,
    ...initialFilters
  });

  const fetchStockStatusReport = useCallback(async (overrideFilters = {}) => {
    try {
      setLoading(true);
      setError(null);

      const finalFilters = {
        ...filters,
        ...overrideFilters
      };

      const response = await ReportsService.getStockStatusReport(finalFilters);

      setSummary(response?.summary || null);
      setBranchSummary(response?.branchSummary ?? []);
      setData(response?.data || []);
      setTotal(response?.summary?.totalItems || response?.data?.length || 0);

    } catch (err) {
      console.error('Failed to fetch Stock Status Report:', err);
      setError(err);
      toast.error('Failed to load stock status report');
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchStockStatusReport();
  }, [fetchStockStatusReport]);

  return {
    data,
    summary,
    branchSummary,
    total,
    loading,
    error,
    filters,
    setFilters,
    refresh: fetchStockStatusReport
  };
};

export default useStockStatus;
